import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import data from "../data/db.json"

export default function SingleAccessory() {
  const [card, setCard] = useState([])
  const [value, setValue] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const { name } = useParams()

  useEffect(() => {
    setIsLoading(true)
    const findAccessory = () => {
      const newAccessory = data.accessories.find(
        (accessory) => accessory.name === name
      )
      setCard(newAccessory)
    }

    findAccessory()
    setIsLoading(false)
  }, [name])

  return (
    <>
      <section>
        {isLoading ? (
          <h1>Loading...</h1>
        ) : (
          <>
            <div className="accessories">
              <div className="accessories-heading flex flex-col items-start justify-center text-left">
                <article className="px-5 lg:container lg:mx-auto 2xl:px-0">
                  <h2 className="capitalize text-white">{card.name}</h2>
                  <p className="mt-3 text-slate-300">{card.desc}</p>
                </article>
              </div>
            </div>

            <div className="py-10 lg:py-20 lg:max-w-7xl px-5 lg:mx-auto 2xl:px-0">
              <article className="lg:grid grid-cols-2 gap-5">
                <div>
                  <div>
                    <img
                      src={card.images[value]}
                      alt=""
                      style={{ height: 400 }}
                    />
                  </div>
                </div>

                <div className="mt-5">
                  <h5>Features</h5>
                  {card.features.map((f, index) => (
                    <li key={index} className="text-slate-700 text-sm">
                      {f}
                    </li>
                  ))}

                  <article>
                    <p className="mt-5 font-bold">{card.price}</p>
                  </article>

                  <ul className="mt-5">
                    <li className="grid grid-cols-3 gap-5 sm:grid-cols-5 md:grid-cols-6">
                      {card.images.map((image, index) => (
                        <img
                          src={image}
                          key={index}
                          alt={card.name}
                          onClick={() => setValue(index)}
                          className="cursor-pointer hover:scale-110 transition-all duration-300"
                        />
                      ))}
                    </li>
                  </ul>

                  <button className="btn-black mt-5">I want this</button>
                </div>
              </article>
            </div>
          </>
        )}
      </section>
    </>
  )
}
